import React from "react";
import {connect} from "react-redux";
import Iframe from 'react-iframe'
import {Dropdown} from "react-bootstrap";
import {__, HelpFunctions} from "../../tools/HelpFunctions";
import {
    changeVersionDocumentCards,
    collectDataForAdditionalSections_Normal,
    createDocumentCards,
    createPreviewBySelectDocument,
    createRedactorData,
    resetDocumentPreview,
    selectActiveDocumentCard,
    selectActiveFileForPreview,
    selectActiveFileForPreview_Card,
    selectViewActiveFileForPreview,
    setFilesContent,
    setSizePreview
} from "../../store/documents/actionCreators/document_PreviewActionCreator";
import {
    AdminLevelEnum,
    ModalTypes, RootComponentsStateViewModeTypes as rootStateType,
    RootComponentsStateViewModeTypes,
    UserSettingsActionsTypes,
    UserSettingsNames
} from "../../tools/StaticTypes";
import {changeDocumentViewMode} from "../../store/documents/actionCreators/document_RootStateActionCreator";
import {MyTooltip} from "../overPage/tooltip/MyTooltip";
import {
    addModalData,
    setLoaderModalData,
    setModalData,
    setStateLeftAsideMenu
} from "../../store/globalState/actionCreators/globalState_AppActionCreator";
import {Link} from "react-router-dom";
import {history, store} from "../../index";
import {updateUserSettings} from "../../store/globalState/actionCreators/globalState_SettingsActionCreator";
import {changeViewMode} from "../../store/documents/actionCreators/document_SearchActionCreator";
import {createUniqueIdString} from "../../tools/CreateUniqueId";
import FilesListDropdown from "./FilesListDropdown";
import {
    combineMainTableAttributes,
    mainTableDownloadDocCollection, selectActiveRow
} from "../../store/documents/actionCreators/document_MainTableActionCreator";
import {treeSelectNode} from "../../store/documents/actionCreators/document_TreeActionCreator";
import {API, API_GET_LINK} from "../../tools/API_NEW/API";
import {DocFilePart} from "../../tools/API_NEW/ServerTypes";
import FileDownloadComponent from "../../tools/FileDownloadComponent";
import {
    DOCUMENT_PREVIEW_ACTIONS,
    DOCUMENT_TEMPORARY_DATA,
    MAIN_TABLE_ACTIONS
} from "../../store/documents/documentActionsList";
import parse from "html-react-parser";
import sanitizeHtml from "sanitize-html";
import {apiRequest, apiRequestNew} from "../../tools/API/apiRequest";
import {addToEndUrl, apiUrl} from "../../tools/API/apiUrl";

import "../../media/styles/docPreview.css";
import {APP_ACTIONS} from "../../store/globalState/globalStateActionsList";

class DocPreview extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            backToTableTooltipShow : false,
            addNewCardTooltipShow : false,
            selectFileTooltipShow : false,
            halfScreenTooltipShow : false,
            fullScreenTooltipShow : false,
            openInNewTabTooltipShow : false,
            infoTooltipShow: false,
            showPreviewShow: false,
            hidePreviewShow: false,
            redactorModeTooltipShow : false,
            uploadFileTooltipShow : false,
            uploadFileAttachmentTooltipShow : false,
            deleteDocumentTooltipShow : false,
            updateFileTooltipShow:false,
            recreateFileTooltipShow:false,
            rotateIcon : false,

            imgStyle: {},
            activeImgLink: null,
            updateCounter: 0,
        };

        this.backToTableRef = React.createRef();
        this.showPreviewRef = React.createRef();
        this.addNewCardRef = React.createRef();
        this.hidePreviewRef = React.createRef();
        this.selectFileRef = React.createRef();
        this.halfScreenRef = React.createRef();
        this.fullScreenRef = React.createRef();
        this.openInNewTabRef = React.createRef();
        this.redactorModeRef = React.createRef();
        this.uploadFileRef = React.createRef();
        this.uploadFileAttachmentRef = React.createRef();
        this.deleteDocumentRef = React.createRef();
        this.infoRef = React.createRef();
        this.recreateFile=React.createRef();
        this.updateFile=React.createRef();

        this.selectActivePreviewFile = this.selectActivePreviewFile.bind(this);
        this.toggleSizePreview = this.toggleSizePreview.bind(this);
        this.backToTable = this.backToTable.bind(this);
        this.addNewCard = this.addNewCard.bind(this);
        this.toggleRedactorMode = this.toggleRedactorMode.bind(this);
        this.uploadFile = this.uploadFile.bind(this);
        this.uploadFileAttachment = this.uploadFileAttachment.bind(this);
        this.saveRedactorChanges = this.saveRedactorChanges.bind(this);
        this.deleteDocument = this.deleteDocument.bind(this);

        this.redactorDataOn = this.redactorDataOn.bind(this);
        this.redactorDataOff = this.redactorDataOff.bind(this);
        this.onbeforeunload = this.onbeforeunload.bind(this);
        this.onMoveBackOrFrontHistory = this.onMoveBackOrFrontHistory.bind(this);
        this.selectViewActiveFile = this.selectViewActiveFile.bind(this);
        this.recreatePreviewDoc=this.recreatePreviewDoc.bind(this)
        this.refreshFilesSection=this.refreshFilesSection.bind(this)
    }

    componentDidMount(){
        let size = this.props.preview.fixingPreview;
        const isViewcard = this.props.rootState.viewMode === RootComponentsStateViewModeTypes.DocumentsApp.PreviewCards;
        if(size === "normal"){
            this.props.changeDocumentViewMode({
                ViewMode: isViewcard ? this.props.rootState.viewMode : RootComponentsStateViewModeTypes.DocumentsApp.PreviewNormal,
                Next : {
                    action: () => {
                        this.props.setSizePreview({
                            fixingPreview:"normal"
                        })
                    },
                    params : {}
                }
            });
        }
        else if (size === "fullScreen"){
            if (this.props.rootState.viewMode === RootComponentsStateViewModeTypes.DocumentsApp.PreviewNormal ||
                this.props.rootState.viewMode === RootComponentsStateViewModeTypes.DocumentsApp.PreviewNormal_PreviewHalfScreen) {
                this.props.changeDocumentViewMode({
                    ViewMode: RootComponentsStateViewModeTypes.DocumentsApp.PreviewNormal_PreviewFullScreen,
                    Next : {
                        action: () => {
                            this.props.setSizePreview({
                                fixingPreview:size
                            })
                        },
                        params : {}
                    }
                });
            } else {
                this.props.changeDocumentViewMode({
                    ViewMode: RootComponentsStateViewModeTypes.DocumentsApp.PreviewNormal,
                    Next : {
                        action: () => {
                            this.props.setSizePreview({
                                fixingPreview:"normal"
                            })
                        },
                        params : {}
                    }
                });
            }
        }
        else if (size === "halfScreen") {
            if (this.props.rootState.viewMode === RootComponentsStateViewModeTypes.DocumentsApp.PreviewNormal ||
                this.props.rootState.viewMode === RootComponentsStateViewModeTypes.DocumentsApp.PreviewNormal_PreviewFullScreen) {
                this.props.changeDocumentViewMode({
                    ViewMode: RootComponentsStateViewModeTypes.DocumentsApp.PreviewNormal_PreviewHalfScreen,
                    Next : {
                        action: () => {
                            this.props.setSizePreview({
                                fixingPreview:"halfScreen"
                            })
                        },
                        params : {}
                    }
                });
            } else if (this.props.rootState.viewMode === RootComponentsStateViewModeTypes.DocumentsApp.PreviewNormal_PreviewHalfScreen) {
                this.props.changeDocumentViewMode({
                    ViewMode: RootComponentsStateViewModeTypes.DocumentsApp.PreviewNormal,
                    Next : {
                        action: () => {
                            this.props.setSizePreview({
                                fixingPreview:"normal"
                            })
                        },
                        params : {}
                    }
                });
            } else {
                this.props.changeDocumentViewMode({
                    ViewMode: RootComponentsStateViewModeTypes.DocumentsApp.PreviewNormal,
                    Next : {
                        action: () => {
                            this.props.setSizePreview({
                                fixingPreview:"normal"
                            })
                        },
                        params : {}
                    }
                });

            }
        }
        else if (size === "hide") {
            this.props.changeDocumentViewMode({
                ViewMode: RootComponentsStateViewModeTypes.DocumentsApp.PreviewNormal_Hide,
                Next : {
                    action: () => {
                        this.props.setSizePreview({
                            fixingPreview:size
                        })
                    },
                    params : {}
                }
            });
        }
        this.setState({imgStyle: {width: '100%'}})
    }

    async recreatePreviewDoc(type){
        let fileId=this.props.preview.activeFile.id
        let result=await API.documents().resetDocPreviewFile({
            id: this.props.preview.activeFile.id,
            isAvailable:true,
        })
        if (result?.errorCode) {
           this.props.setModalData({
               name: ModalTypes.app.info,
               data: {type: "fail", content: `Действие не было выполнено: <br/>${result.message.Message}`}
           });
           return;
       }

        if(result===true){
              let resultDownloadFile=await API.documents().downloadDocFile({
                  id:fileId,
                  part:DocFilePart.Preview,
                  isAttachment:false,
              })

            if(resultDownloadFile.status==200){
                await this.props.resetDocumentPreview({
                    Next:{
                        action:()=>{
                            this.props.createPreviewBySelectDocument({});
                            this.setState({ updateCounter: this.state.updateCounter + 1 });
                        }
                    }
                });

                this.props.setModalData({
                    name: ModalTypes.app.info,
                    data: {type: "success", content: "Файл успешно пересоздан!"}
                });
            }else if (resultDownloadFile?.errorCode) {
                this.props.setModalData({
                    name : ModalTypes.app.info,
                    data : {content : "Ошибка пересоздания", type : "fail"}
                });
            }
        }
    }


    onbeforeunload(event) {
        if(this.props.redactorDataIsUpdated) {
            event.preventDefault();

            return event.returnValue = "Are you sure you want to exit?";
        }
    }

    onMoveBackOrFrontHistory(event) {
        if(this.props.redactorDataIsUpdated) {
            alert("Возможно имеются несохраненные данные. Они будут утеряны.");
            this.redactorDataOff();
            return event.preventDefault();
        }
    }

    redactorDataOn() {
        window.onbeforeunload = this.onbeforeunload;
        window.addEventListener("popstate", this.onMoveBackOrFrontHistory);
    }

    redactorDataOff() {
        window.onbeforeunload = null;
        window.removeEventListener("popstate", this.onMoveBackOrFrontHistory);
    }

    deleteDocument(){
        this.props.setModalData({
            name: ModalTypes.documents.mainTable.DeleteDocument,
            data: {
                type : "deleteDocument",
                IdDoc : this.props.activeRow.Info.Id,
                Name : `${this.props.activeRow.Info.Name} ${this.props.activeRow.Info.ShortDescription ?? ""}`,
                isMark : this.props.activeRow.Info.IsMarkedForDelete
            }
        });
    }

    // меняем активный файл предпросмотра
    async selectActivePreviewFile(item, index) {
        const isViewcard = this.props.rootState.viewMode === RootComponentsStateViewModeTypes.DocumentsApp.PreviewCards;
        // const isViewRedactorMode = this.props.rootState.viewMode === RootComponentsStateViewModeTypes.DocumentsApp.PreviewCards_RedactorMode;
        this.props.setFilesContent({
            document: item.isAttach ? item : this.props.activeRow.Info,
            isCard: isViewcard,
            isRedactorMode: false
        });
        if (this.props.viewMode === "normal") {
            this.props.selectActiveFileForPreview({
                Type: item.type,
                Index: index,
                File:item,
            });
        } else if (this.props.viewMode === "card") {
            this.props.selectActiveFileForPreview_Card({
                CardId: this.props.cards.activeCardId,
                ActiveFileIndex: index,
                Type: item.type,
            });
            // this.props.resetDocumentPreview({});
            this.setState({ updateCounter: this.state.updateCounter + 1 });
        }
    }

    // переключение между обычным режимом и режимом редактирования
    toggleRedactorMode() {
        if (this.props.rootState.viewMode === RootComponentsStateViewModeTypes.DocumentsApp.PreviewCards_RedactorMode ||
            this.props.rootState.viewMode === RootComponentsStateViewModeTypes.DocumentsApp.PreviewCards_RedactorMode_HalfScreen ||
            this.props.rootState.viewMode === RootComponentsStateViewModeTypes.DocumentsApp.PreviewCards_RedactorMode_FullScreen) {

            this.redactorDataOff();
            this.props.changeDocumentViewMode({
                ViewMode: RootComponentsStateViewModeTypes.DocumentsApp.PreviewCards,
                Next: {
                    action: () => {
                        this.props.createRedactorData({
                            CardId: null
                        });
                    },
                    params: {}
                }
            });
        } else {
            this.redactorDataOn();
            // меняем версию на последнюю
            // после копируем данные для редактирования
            // и меняем режим отображения на редактирование
            this.props.changeVersionDocumentCards({
                VersionIndex: 0,
                CardId: this.props.cards.activeCardId,
                Next: {
                    action: () => {
                        this.props.createRedactorData({
                            CardId: this.props.cards.activeCardId,
                            Next: {
                                action: () => {
                                    this.props.changeDocumentViewMode({
                                        ViewMode: RootComponentsStateViewModeTypes.DocumentsApp.PreviewCards_RedactorMode
                                    });
                                },
                                params: {}

                            }
                        });
                    },
                    params: {}
                }
            });
        }
    }


    // отображение модального окна для проверки введенных данных
    saveRedactorChanges(card) {
        let redactorData = {...store.getState().document.cards.redactorData};
        let originalData = store.getState().document.cards.collection
            .find(card => card.Id === store.getState().document.cards.activeCardId);

        let isUpdatedInAll = false;

        let changedDocType = {
            old : originalData.additionalSections.docTypeSection,
            new : redactorData.additionalSections.docTypeSection,
            isUpdated : originalData.additionalSections.docTypeSection.TypeId !== redactorData.additionalSections.docTypeSection.TypeId,
        }

        if(originalData.additionalSections.docTypeSection.TypeId !== redactorData.additionalSections.docTypeSection.TypeId) {
            isUpdatedInAll = true;
        }

        let changedAttributes = [];
        const lRedactorData = __.convertAttributesArrayToUnique(redactorData.additionalSections.attributesSection.attributes, 'Value');
        const lOriginalData = __.convertAttributesArrayToUnique(originalData.additionalSections.attributesSection.attributes, 'Value');
        for(let i = 0; i < lRedactorData.length; i++) {
            let redItem = lRedactorData[i];
            let origItem = lOriginalData[i];
            const isUpdatedValue =
                !__.isAttributeValuesEquals(origItem.Value, redItem.Value)
                || !__.isAttributeValuesEquals(origItem.IdDictionaryValue, redItem.IdDictionaryValue);
            changedAttributes.push({
                old : origItem,
                new : redItem,
                isUpdated : isUpdatedValue
            });
            if (isUpdatedValue) {
                isUpdatedInAll = true;
            }
        }

        let changedContent = {
            old : originalData.additionalSections.contentSection.content,
            new : redactorData.additionalSections.contentSection.content,
            isUpdated : originalData.additionalSections.contentSection.content !== redactorData.additionalSections.contentSection.content,
        };
        if(originalData.additionalSections.contentSection.content !== redactorData.additionalSections.contentSection.content) {
            isUpdatedInAll = true;
        }

        let changedFiles = {
            newFiles : redactorData.additionalSections.filesSection.newFiles,
            deleteFiles : redactorData.additionalSections.filesSection.deleteFiles,
            files : [],
            idMainFile : redactorData.additionalSections.filesSection.idMainFile,
            idMainFileOriginal : redactorData.additionalSections.filesSection.idMainFileOriginal,
        };

        for(let i = 0; i < redactorData.additionalSections.filesSection.files.length; i++) {
            let isUpdated = originalData.additionalSections.filesSection.files[i].name !== redactorData.additionalSections.filesSection.files[i].name
                ||  originalData.additionalSections.filesSection.files[i].description !== redactorData.additionalSections.filesSection.files[i].description;
            changedFiles.files.push({
                old : originalData.additionalSections.filesSection.files[i],
                new : redactorData.additionalSections.filesSection.files[i],
                isUpdated : isUpdated
            });
            if(isUpdated) {
                isUpdatedInAll = true;
            }
        }

        if (changedFiles.newFiles.length > 0 || changedFiles.deleteFiles.length > 0) {
            isUpdatedInAll = true;
        }
        if (changedFiles.idMainFile !== changedFiles.idMainFileOriginal) {
            isUpdatedInAll = true;
        }

        const updateStore = (isUpdatedInAllValue) => {
            store.dispatch({type : DOCUMENT_PREVIEW_ACTIONS.CHECK_INPUT_DATA_BEFORE_UPDATE, payload : {
                    isUpdatedInAll : isUpdatedInAllValue,
                    attributes : changedAttributes,
                    content : changedContent,
                    files : changedFiles,
                    docType: changedDocType
            }});
        }

        if (!isUpdatedInAll) {
            updateStore(false)
            this.props.setModalData({
                name: ModalTypes.app.info,
                data: {type: "fail", content: 'Нет данных для сохранения.'}
            });
        } else {
            let wasBreak = false
            for (const el of changedAttributes) {
                if ((el.new.IsConstant || el.new?.IsRequired) && (el.new.Value === "" || el.new.Value === null || el.new.Value === undefined)) {
                    updateStore(false)
                    this.props.setModalData({
                        name: ModalTypes.app.info,
                        data: {
                            type: "fail",
                            content: `Изменения не сохранены <br/> Не заполнен обязательный атрибут "${el.new.ColumnName}"`
                        }
                    })
                    wasBreak = true
                    break
                }
                if (Array.isArray(el.new?.Value) && el.new.Value.some(el => !el || el === '')) {
                    updateStore(false)
                    this.props.setModalData({
                        name: ModalTypes.app.info,
                        data: {
                            type: "fail",
                            content: `Изменения не сохранены <br/> Не заполнено поле множественного атрибута "${el.new.ColumnName}"`
                        }
                    });
                    wasBreak = true
                    break
                }
            }
            if (!wasBreak) {
                updateStore(true)
                this.props.setModalData({
                    name: ModalTypes.documents.additionalSection.ChangeDocAttributes,
                    data: {
                        redactorDataOff: this.redactorDataOff,
                    }
                });
            }
        }
    }

    // изменяем размер предпросмотра
    // TODO: доделать для режима редактирования
    toggleSizePreview(size) {
        this.setState({rotateIcon: !this.state.rotateIcon})
        if (this.props.rootState.viewMode === RootComponentsStateViewModeTypes.DocumentsApp.PreviewCards ||
            this.props.rootState.viewMode === RootComponentsStateViewModeTypes.DocumentsApp.PreviewCards_HalfScreen ||
            this.props.rootState.viewMode === RootComponentsStateViewModeTypes.DocumentsApp.PreviewCards_FullScreen) {
            if (size === "fullScreen") {
                if (this.props.rootState.viewMode === RootComponentsStateViewModeTypes.DocumentsApp.PreviewCards_FullScreen) {
                    this.props.changeDocumentViewMode({
                        ViewMode: RootComponentsStateViewModeTypes.DocumentsApp.PreviewCards
                    });
                } else {
                    this.props.changeDocumentViewMode({
                        ViewMode: RootComponentsStateViewModeTypes.DocumentsApp.PreviewCards_FullScreen
                    });
                }
            } else if (size === "halfScreen") {
                if (this.props.rootState.viewMode === RootComponentsStateViewModeTypes.DocumentsApp.PreviewCards ||
                    this.props.rootState.viewMode === RootComponentsStateViewModeTypes.DocumentsApp.PreviewCards_FullScreen) {
                    this.props.changeDocumentViewMode({
                        ViewMode: RootComponentsStateViewModeTypes.DocumentsApp.PreviewCards_HalfScreen
                    });
                } else {
                    this.props.changeDocumentViewMode({
                        ViewMode: RootComponentsStateViewModeTypes.DocumentsApp.PreviewCards
                    });
                }
            }
        } else if (this.props.rootState.viewMode === RootComponentsStateViewModeTypes.DocumentsApp.PreviewCards_RedactorMode ||
            this.props.rootState.viewMode === RootComponentsStateViewModeTypes.DocumentsApp.PreviewCards_RedactorMode_HalfScreen ||
            this.props.rootState.viewMode === RootComponentsStateViewModeTypes.DocumentsApp.PreviewCards_RedactorMode_FullScreen) {
            if (size === "fullScreen") {
                if (this.props.rootState.viewMode === RootComponentsStateViewModeTypes.DocumentsApp.PreviewCards_RedactorMode_FullScreen) {
                    this.props.changeDocumentViewMode({
                        ViewMode: RootComponentsStateViewModeTypes.DocumentsApp.PreviewCards_RedactorMode
                    });
                } else {
                    this.props.changeDocumentViewMode({
                        ViewMode: RootComponentsStateViewModeTypes.DocumentsApp.PreviewCards_RedactorMode_FullScreen
                    });
                }
            } else if (size === "halfScreen") {
                if (this.props.rootState.viewMode === RootComponentsStateViewModeTypes.DocumentsApp.PreviewCards_RedactorMode ||
                    this.props.rootState.viewMode === RootComponentsStateViewModeTypes.DocumentsApp.PreviewCards_RedactorMode_FullScreen) {
                    this.props.changeDocumentViewMode({
                        ViewMode: RootComponentsStateViewModeTypes.DocumentsApp.PreviewCards_RedactorMode_HalfScreen
                    });
                } else {
                    this.props.changeDocumentViewMode({
                        ViewMode: RootComponentsStateViewModeTypes.DocumentsApp.PreviewCards_RedactorMode
                    });
                }
            }
        } else {
            if (size === "fullScreen") {
                if (this.props.rootState.viewMode === RootComponentsStateViewModeTypes.DocumentsApp.PreviewNormal ||
                    this.props.rootState.viewMode === RootComponentsStateViewModeTypes.DocumentsApp.PreviewNormal_PreviewHalfScreen) {
                    this.props.changeDocumentViewMode({
                        ViewMode: RootComponentsStateViewModeTypes.DocumentsApp.PreviewNormal_PreviewFullScreen,
                        Next : {
                            action: () => {
                                this.props.setSizePreview({
                                    fixingPreview:size
                                })
                            },
                            params : {}
                        }
                    });
                } else {
                    this.props.changeDocumentViewMode({
                        ViewMode: RootComponentsStateViewModeTypes.DocumentsApp.PreviewNormal,
                        Next : {
                            action: () => {
                                this.props.setSizePreview({
                                    fixingPreview:"normal"
                                })
                            },
                            params : {}
                        }
                    });
                }
            } else if (size === "halfScreen") {
                if (this.props.rootState.viewMode === RootComponentsStateViewModeTypes.DocumentsApp.PreviewNormal ||
                    this.props.rootState.viewMode === RootComponentsStateViewModeTypes.DocumentsApp.PreviewNormal_PreviewFullScreen) {
                    this.props.changeDocumentViewMode({
                        ViewMode: RootComponentsStateViewModeTypes.DocumentsApp.PreviewNormal_PreviewHalfScreen,
                        Next : {
                            action: () => {
                                this.props.setSizePreview({
                                    fixingPreview:"halfScreen"
                                })
                            },
                            params : {}
                        }
                    });
                } else if (this.props.rootState.viewMode === RootComponentsStateViewModeTypes.DocumentsApp.PreviewNormal_PreviewHalfScreen) {
                    this.props.changeDocumentViewMode({
                        ViewMode: RootComponentsStateViewModeTypes.DocumentsApp.PreviewNormal,
                        Next : {
                            action: () => {
                                this.props.setSizePreview({
                                    fixingPreview:"normal"
                                })
                            },
                            params : {}
                        }
                    });
                } else {
                    this.props.changeDocumentViewMode({
                        ViewMode: RootComponentsStateViewModeTypes.DocumentsApp.PreviewNormal,
                        Next : {
                            action: () => {
                                this.props.setSizePreview({
                                    fixingPreview:"normal"
                                })
                            },
                            params : {}
                        }
                    });

                }
            } else if (size === "hide") {
                this.props.changeDocumentViewMode({
                    ViewMode: RootComponentsStateViewModeTypes.DocumentsApp.PreviewNormal_Hide,
                    Next : {
                        action: () => {
                            this.props.setSizePreview({
                                fixingPreview:size
                            })
                        },
                        params : {}
                    }
                });
            }
        }
    }

    // возвращаемся в реестр документов (к таблице)
    async backToTable() {
        // this.props.setModalData({
        //     name: ModalTypes.app.alert,
        //     data: {
        //         content: "Загрузка...",
        //         disableButton: true,
        //         fullBackground: false,
        //         gif: "documents"
        //     }
        // });

        //Новый прелоадер
        store.dispatch(setLoaderModalData({
            data : {content : "Загрузка...", disableButton : true, fullBackground : false, gif : "documents", key : "DocPreview489"}
        }));

        let card = this.props.cards.collection.find(card => card.Id === this.props.cards.activeCardId);

        // todo tp №22896
        await this.props.changeDocumentViewMode({ViewMode: RootComponentsStateViewModeTypes.DocumentsApp.PreviewNormal});
        if (this.props.activeRow === null || this.props.activeRow.Info.Id !== card.IdDoc) {
            const group_tree = __.findGroup(this.props.tree_docs, card.IdDocGroup, false, true);
            const type_tree = group_tree.children.find(type => type.info.Id === card.TypeId);
            await this.props.treeSelectNode({Node: type_tree});
            await this.props.mainTableDownloadDocCollection({
                id: card.IdDoc,
                ActiveNode: type_tree
            });
            await this.props.combineMainTableAttributes({ActiveNode: type_tree});
            let activeRow = store.getState().document.mainTable.body.find(tr => tr.Version.IdDoc === card.IdDoc);
            await this.props.selectActiveRow({RowInfo: activeRow});
            await this.props.resetDocumentPreview({});
            await this.props.createPreviewBySelectDocument({});
        }

        if(this.props.activeRow) {
            await this.props.collectDataForAdditionalSections_Normal({});
        }

        await this.props.selectActiveDocumentCard({});
        if (!this.props.rootState.isOpenAsideMenu) {
            this.props.setStateLeftAsideMenu({
                isClose: false,
                rootName: "DocumentApp"
            });
        }

        let link = this.props.router.location.pathname + this.props.router.location.search.split("&c")[0];
        history.push(link);

        // this.props.setModalData({});
        //Новый прелоадер
        this.props.setLoaderModalData({keyDeleted: "DocPreview501"});
    }

    async addNewCard() {
        // this.props.setModalData({
        //     name: ModalTypes.app.alert,
        //     data: {content: "Загрузка...", disableButton: true, fullBackground: false, gif: "documents"}
        // });
        //Новый прелоадер
        store.dispatch(setLoaderModalData({
            data : {content : "Загрузка...", disableButton : true, fullBackground : false, gif : "documents", key : "DocPreview528"}
        }));

        this.props.createDocumentCards({
            IdDoc: this.props.activeRow.Version.IdDoc,
            IdVersion: this.props.activeRow.Version.Id,
            Next: {
                action: () => {
                    this.props.selectActiveDocumentCard({
                        CardId: this.props.cards.collection.find(card => card.IdDoc == this.props.activeRow.Version.IdDoc).Id,
                        Next: {
                            action: () => {
                                this.props.changeDocumentViewMode({
                                    ViewMode: RootComponentsStateViewModeTypes.DocumentsApp.PreviewCards,
                                    Next: {
                                        action: () => {
                                            // this.props.setModalData({});
                                            //Новый прелоадер
                                            this.props.setLoaderModalData({keyDeleted: "DocPreview546"});
                                        },
                                        params: {}
                                    }
                                })
                            },
                            params: {}
                        }
                    });
                    // if(this.props.rootState.isOpenAsideMenu) {
                        this.props.setStateLeftAsideMenu({
                            isClose: true,
                            rootName: "DocumentApp"
                        });
                    // }
                    this.props.updateUserSettings({
                        Name: UserSettingsNames.DOCUMENT_CONFIG,
                        Action: UserSettingsActionsTypes.Update,
                        Data: {
                            IdDoc: this.props.activeRow.Version.IdDoc,
                            IdVersion: this.props.activeRow.Version.Id,
                            Name: `${this.props.activeRow.Info.Name} ${this.props.activeRow.Info.ShortDescription ?? ""}`
                        }
                    });
                    this.props.changeViewMode({
                        isSearch: false
                    });
                },
                params: {}
            }
        });
    }

    // прикрепление основного файла
    uploadFile() {
        // this.props.setModalData({
        //     name : ModalTypes.documents.additionalSection.DownloadDoc,
        //     data : {
        //         type : "main"
        //     }
        // });
    }

    // прикрепление дополнительных файлов
    uploadFileAttachment() {
        this.props.setModalData({
            name: ModalTypes.documents.additionalSection.DownloadDoc,
            data: {
                type: "attachment",
            }
        });
    }

    selectViewActiveFile(type) {
        const isViewcard = this.props.rootState.viewMode === RootComponentsStateViewModeTypes.DocumentsApp.PreviewCards ||
            this.props.rootState.viewMode === RootComponentsStateViewModeTypes.DocumentsApp.PreviewCards_RedactorMode;
        // const isViewRedactorMode = this.props.rootState.viewMode === RootComponentsStateViewModeTypes.DocumentsApp.PreviewCards_RedactorMode;
        this.props.selectViewActiveFileForPreview({View: type, isCard: isViewcard, isRedactorMode: false});
    }


    async refreshFilesSection() {
        let {IdDoc, Id} = store.getState().document.mainTable.activeRow.Version;

        const newFilesResponse = await API.documents().getFilesByVersion({
            idDoc: IdDoc,
            idVersion: Id
        });


        let newFiles = [];
        let previewPdf = newFilesResponse.Records.find(file => file.AttributeName.Id === 2);
        if (previewPdf) {
            newFiles.push({
                id: previewPdf.Id,
                name: previewPdf.Name,
                link: addToEndUrl({
                    url: apiUrl.DOCUMENTS.DOWNLOAD_FILE.url,
                    collection: [
                        previewPdf.Id,
                        Id,
                        "true" // для просмотра (true - для загрузки)
                    ]
                }),
                type: previewPdf.Name.toLowerCase().indexOf(".pdf") > 0 ? "pdf" : "image",
                description: previewPdf.Description,
                size: previewPdf.Size,
                signatures: previewPdf.signatures,
                idVersion: Id
            });
        }


        // прикрепленные файлы
        let otherFiles = newFilesResponse.Records.filter(file => file.AttributeName.Id === 4);
        if (otherFiles) {
            for (let i = 0; i < otherFiles.length; i++) {
                newFiles.push({
                    id: otherFiles[i].Id,
                    name: otherFiles[i].Name,
                    link: addToEndUrl({
                        url: apiUrl.DOCUMENTS.DOWNLOAD_FILE.url,
                        collection: [
                            previewPdf.Id,
                            Id,
                            "true" // для просмотра (true - для загрузки)
                        ]
                    }),
                    type: otherFiles[i].Name.toLowerCase().indexOf(".pdf") > 0 ? "pdf" : "image",
                    description: otherFiles[i].Description,
                    size: otherFiles[i].Size,
                    isAttach: true,
                    signatures: previewPdf.signatures,
                });
            }
        }


        if (newFiles) {
            await store.dispatch({type: DOCUMENT_PREVIEW_ACTIONS.CREATE_BY_NEW_OPEN_DOC, payload: newFiles});
        }
    }


    render() {
        let isRedactorMode = false;
        if (this.props.rootState.viewMode === RootComponentsStateViewModeTypes.DocumentsApp.PreviewCards_RedactorMode ||
            this.props.rootState.viewMode === RootComponentsStateViewModeTypes.DocumentsApp.PreviewCards_RedactorMode_HalfScreen ||
            this.props.rootState.viewMode === RootComponentsStateViewModeTypes.DocumentsApp.PreviewCards_RedactorMode_FullScreen) {
            isRedactorMode = true;
        }

        const deleteAccess = this.props.activeNode?.info.DeleteAccess
        const modifyAccess = this.props.activeNode?.info.ModifyAccess

        let preview = this.props.preview;
        let documentName = "";

        // обычный режим отображения
        if (this.props.viewMode === "normal") {
            preview = this.props.preview;
            documentName = this.props.activeRow ? `${this.props.activeRow.Info.Name} ${this.props.activeRow.Info.ShortDescription ?? ""}` : "";
        }
        // режим если отображается карточка документа
        else if (this.props.viewMode === "card") {
            let card = this.props.cards.collection.find(card => card.Id === this.props.cards.activeCardId);
            if (!card)
                return (<></>);
            preview = card.preview;
            documentName = `${card.name} ${card.ShortDescription ?? ""}`;
        }


        let body = <div className="card-body"/>;
        let activeLink = "";
        if (preview.isReady) {
            // let card = preview.typeFile==undefined
            if (preview.activeView === "preview") {
                if(preview.files[preview.activeFileIndex]?.previewLink?.includes("?")){
                    activeLink = preview.files[preview.activeFileIndex]?.previewLink + `&t=${new Date().getTime()}`;
                }else{
                    activeLink = preview.files[preview.activeFileIndex]?.previewLink + `?t=${new Date().getTime()}`;
                }
                // activeLink = preview.files[preview.activeFileIndex]?.previewLink;
                    body = (
                        <div className="card-body preview-container">
                            <div className={`img-container beautiful-scroll-10`}>
                            <img src={`${activeLink}`} alt="" style={{
                                ...this.state.imgStyle,
                                boxShadow: "0 0 15px -5px grey",
                                cache: 'no-store'
                            }}/>
                            </div>

                            {this.props.viewMode === "normal" &&
                                <div className={'d-flex'}>
                                    <div title="Пересоздать"
                                         onClick={async () => {
                                             await this.props.setModalData({
                                                     name: ModalTypes.app.info,
                                                     data: {
                                                         type: "question",
                                                         content: `Вы действительно хотите пересоздать предпросмотр документа?`,
                                                         disableButton: false,
                                                         fullBackground: false,
                                                             onClickContinue: async () => {
                                                                 await API.documents().resetDocPreviewFile({
                                                                     id: this.props.preview.activeFile.id,
                                                                     isAvailable: true,
                                                                 })
                                                                 this.props.setModalData({});
                                                                 this.props.setModalData({
                                                                     name: ModalTypes.app.info,
                                                                     data: {type: "success", content: `Файл предпросмотра успешно сброшен`}
                                                                 });
                                                                 this.setState({ updateCounter: this.state.updateCounter + 1 });
                                                             }
                                                     }})}}
                                        >
                                        <span className={`btn btn-icon btn-sm`}>
                                            <i className={`svg-icon icon-Reload icon-color-primary`}/>
                                        </span>
                                    </div>

                                    <div title="Обновить"
                                         onClick={async () => {
                                             this.props.addModalData({
                                                 name: ModalTypes.documents.updatePreviewFile,
                                                 data: {
                                                     activeFile: this.props.preview.activeFile,
                                                     activeRow: this.props.activeRow.Version.IdDoc,
                                                     preview: this.props.preview,
                                                     activeView: 'preview',
                                                     callback: async () => {
                                                         this.setState({ updateCounter: this.state.updateCounter + 1 })
                                                     }
                                                 }
                                             });

                                         }}
                                    >
                            <span className={`btn btn-icon btn-sm`}>
                                <i className={`svg-icon icon-Doc_view_8 icon-color-primary`}/>
                            </span>
                                    </div>

                                    <div title="Вписать по ширине"
                                         onClick={async () => {
                                             this.setState({imgStyle: {width: '100%'}})
                                         }}
                                    >
                            <span className={`btn btn-icon btn-sm`}>
                                <i className={`svg-icon icon-Doc_view_2 icon-color-primary`}/>
                            </span>
                                    </div>
                                    <div title="Вписать по высоте"
                                         onClick={async () => {
                                             this.setState({imgStyle: {height: '100%'}})
                                         }}
                                    >
                            <span className={`btn btn-icon btn-sm`}>
                                <i className={`svg-icon icon-Doc_view_2 rotate-90 icon-color-primary`}/>
                            </span>
                                    </div>
                                    <div title="Истинный размер"
                                         onClick={async () => {
                                             this.setState({imgStyle: {}})
                                         }}
                                    >
                            <span className={`btn btn-icon btn-sm`}>
                                <i className={`svg-icon icon-Doc_view_3 icon-color-primary`}/>
                            </span>
                                    </div>
                                </div>
                            }
                        </div>
                    );
                //}
                // else {
                //     body = (
                //         <div className="card-body beautiful-scroll-10" style={{width: "100%", height: "100%"}}>
                //             <Iframe url={preview.files[preview.activeFileIndex].previewLink}
                //                     width="100%"
                //                     height="100%"
                //                     id="test"
                //                     display="initial"
                //                     position="relative"
                //             />
                //         </div>
                //     );
                // }
            } else if (preview.activeView === "content") {
                activeLink = preview.files[preview.activeFileIndex].contentLink;
                if(!activeLink){
                    activeLink = "/cit-api/DocFiles/Download/?id=" + preview.files[preview.activeFileIndex].id +"&part=2&isAttachment=false&t=" + new Date().getTime();
                }else{
                    activeLink = activeLink + "&t=" + new Date().getTime();
                }
                let sectionData = ""
                let path = "documents"
                if( this.props.rootState.viewMode === RootComponentsStateViewModeTypes.DocumentsApp.PreviewCards){
                    const cardIndex = this.props.cards.collection.findIndex(card => card.Id === this.props.cards.activeCardId);
                  sectionData = store.getState().document.cards.collection[cardIndex].additionalSections.contentSection
                    path = "cards"
                }else{
                    sectionData = store.getState().document.additionalSections?.state?.contentSection
                    path = "documents"
                }
                let sectionDataText = sanitizeHtml(sectionData.content, {
                    allowedAttributes: {span: ["class", "className"]}
                });

                let content = <pre className="content-text">{parse(sectionDataText)}</pre>;
                body = <div className="card-body beautiful-scroll-10 justify-content-between" style={{width: "100%", height: "100%"}}>
                    {content}

                    <div className={'d-flex'}>
                        {/*<div title="Обновить"*/}
                        {/*     onClick={async () => {*/}
                        {/*         this.props.addModalData({*/}
                        {/*             name: ModalTypes.documents.updatePreviewFile,*/}
                        {/*             data: {*/}
                        {/*                 activeFile: this.props.preview.activeFile,*/}
                        {/*                 activeRow: this.props.activeRow.Version.IdDoc,*/}
                        {/*                 preview: this.props.preview,*/}
                        {/*                 activeView: 'content',*/}
                        {/*                 callback: async () => {*/}
                        {/*                     this.setState({ updateCounter: this.state.updateCounter + 1 })*/}
                        {/*                 }*/}
                        {/*             }*/}
                        {/*         });*/}

                        {/*     }}*/}
                        {/*>*/}
                        {/*    <span className={`btn btn-icon btn-sm`}>*/}
                        {/*        <i className={`svg-icon icon-Doc_view_8 icon-color-primary`}/>*/}
                        {/*    </span>*/}
                        {/*</div>*/}
                        <div title="Изменить содержание"
                             onClick={() => {
                                 this.props.addModalData({
                                     name: ModalTypes.documents.mainTable.EditContent,
                                     data: {
                                         text: sectionData?.content,
                                         docId: preview.files[preview.activeFileIndex].id,
                                         path: path,
                                         cardId: this.props.cards.activeCardId
                                     }
                                 });
                             }}
                        >
                            <span className={`btn btn-icon btn-sm`}>
                                <i className={`svg-icon icon-Table_edit_1 icon-color-primary`}/>
                            </span>
                        </div>

                        <div title="Пересоздать файл содержания"
                             onClick={async () => {
                                 await this.props.setModalData({
                                     name: ModalTypes.app.info,
                                     data: {
                                         type: "question",
                                         content: `Вы действительно хотите пересоздать содержание документа?`,
                                         disableButton: false,
                                         fullBackground: false,
                                         onClickContinue: async () => {
                                             await API.documents().resetDocFileContent({
                                                 id: preview.files[preview.activeFileIndex].id,
                                                 isAvailable: true
                                             })

                                             store.dispatch({
                                                 type: DOCUMENT_PREVIEW_ACTIONS.UPDATE_DATA_FOR_CONTENT_SECTION,
                                                 payload: {contentSection: 'Текст ещё не сгенерирован.'}
                                             })
                                             this.props.setModalData({})
                                             this.props.setModalData({
                                                 name: ModalTypes.app.info,
                                                 data: {type: "success", content: `Содержимое документа успешно изменено`}
                                             });
                                         }
                                     }
                                 });
                             }}
                        >
                            <span className={`btn btn-icon btn-sm`}>
                                <i className={`svg-icon icon-Reload icon-color-primary`}/>
                            </span>
                        </div>

                        {/*<div title="Обновить файл содержания"*/}
                        {/*     onClick={async () => {*/}
                        {/*         this.props.addModalData({*/}
                        {/*             name: ModalTypes.documents.updatePreviewFile,*/}
                        {/*             data: {*/}
                        {/*                 callback: async () => {*/}
                        {/*                     await this.props.collectDataForAdditionalSections_Normal({});*/}
                        {/*                 }*/}
                        {/*             }*/}
                        {/*         });*/}
                        {/*     }}*/}
                        {/*>*/}
                        {/*    <span className={`btn btn-icon btn-sm`}>*/}
                        {/*        <i className={`svg-icon icon-Doc_view_8 icon-color-primary`}/>*/}
                        {/*    </span>*/}
                        {/*</div>*/}
                    </div>
                </div>
            } else {
                // let activeFileIndex = preview.files.findIndex(file => file.type === 'pdf')
                activeLink = preview.files[preview.activeFileIndex].originalLink;

                const lFileName = preview.files[preview.activeFileIndex]['name'];
                const lLastFour = lFileName.substring(lFileName.length - 4).toLowerCase()

                if (lLastFour == '.pdf') {
                    body = (
                        <div className="card-body beautiful-scroll-10 justify-content-between" style={{width: "100%", height: "100%"}}>
                            <Iframe url={activeLink}
                                    width="100%"
                                    height="100%"
                                    id="test"
                                    display="initial"
                                    position="relative"
                            />
                            {this.props.viewMode !== "card" &&
                                <div className={'d-flex'}>
                                    <div title="Обновить оригинал файла"
                                         onClick={async () => {
                                             const idVersion = this.props.activeRow?.Version.Id;
                                             const idDoc = this.props.activeRow?.Version.IdDoc;
                                             this.props.addModalData({
                                                 name: ModalTypes.documents.updatePreviewFile,
                                                 data: {
                                                     activeFile: this.props.preview.activeFile,
                                                     activeRow: this.props.activeRow.Version.IdDoc,
                                                     preview: this.props.preview,
                                                     activeView: 'original',
                                                     callback: async () => {
                                                         let request = new apiRequest(apiUrl.DOCUMENTS.GET_BY_VERSION, {
                                                             idDoc,
                                                             idVersion,
                                                         });
                                                         request.execute(async function (data) {
                                                             let loadFiles = data.Records;

                                                             // сохраняем во временные файлы
                                                             if (loadFiles.length === 0) {
                                                                 store.dispatch({
                                                                     type: APP_ACTIONS.SET_MODAL_DATA, payload: {
                                                                         name: ModalTypes.app.info,
                                                                         data: {
                                                                             content: `Ошибка открытия: файл поврежден`,
                                                                             type: "fail"
                                                                         }
                                                                     }
                                                                 });
                                                                 store.dispatch({
                                                                     type: APP_ACTIONS.SET_LOADER_MODAL_DATA, payload: {
                                                                         keyDeleted: "search_PreviewActionCreator87"
                                                                     }
                                                                 })
                                                                 return false
                                                             }
                                                             await store.dispatch({
                                                                 type: DOCUMENT_TEMPORARY_DATA.SAVE, payload: {
                                                                     name: "DocumentFiles",
                                                                     data: loadFiles
                                                                 }
                                                             });
                                                             const filesSection = [];
                                                             const files = loadFiles?.filter(file => file.AttributeName.Id === 4 || file.AttributeName.Id === 3);
                                                             if(files) {
                                                                 for(let i = 0; i < files.length; i++) {
                                                                     filesSection.push({
                                                                         id : files[i].Id,
                                                                         name : files[i].Name,
                                                                         link : addToEndUrl({
                                                                             url : apiUrl.DOCUMENTS.DOWNLOAD_FILE.url,
                                                                             collection : [
                                                                                 files[i].Id,
                                                                                 idVersion,
                                                                                 "true" // false - для просмотра (true - для загрузки)
                                                                             ]
                                                                         }),
                                                                         type : files[i].Name.toLowerCase().indexOf(".pdf") > 0 ? "pdf" : "image",
                                                                         description : files[i].Description,
                                                                         size : files[i].Size,
                                                                         // signatures: lSignatures ? lSignatures.Records : null,
                                                                     });
                                                                 }
                                                             }
                                                             await store.dispatch({
                                                                 type: DOCUMENT_PREVIEW_ACTIONS.UPDATE_DATA_FOR_FILES_SECTION, payload: {
                                                                     filesSection,
                                                                 }
                                                             });

                                                         });
                                                     }
                                                 }
                                             });
                                         }}
                                    >
                            <span className={`btn btn-icon btn-sm`}>
                                <i className={`svg-icon icon-Doc_view_8 icon-color-primary`}/>
                            </span>
                                    </div>
                                </div>
                            }
                        </div>
                    );
                } else {
                    body = (
                        <div className="card-body beautiful-scroll-10 justify-content-between" style={{width: "100%", height: "100%"}}>
                            <div>
                                <FileDownloadComponent fileUrl={activeLink} fileName={lFileName} fileSize={
                                    preview.files[preview.activeFileIndex].size === undefined ? "—" : `${(preview.files[preview.activeFileIndex].size / 1048576).toFixed(2)} Мбайт`
                                }/>
                            </div>
                            {/*{this.props.viewMode !== "card" &&*/}
                            {/*    <div className={'d-flex'}>*/}
                            {/*        <div title="Обновить оригинал файла"*/}
                            {/*             onClick={async () => {*/}
                            {/*                 this.props.addModalData({*/}
                            {/*                     name: ModalTypes.documents.updatePreviewFile,*/}
                            {/*                     data: {*/}
                            {/*                         activeFile: this.props.preview.activeFile,*/}
                            {/*                         activeRow: this.props.activeRow.Version.IdDoc,*/}
                            {/*                         preview: this.props.preview,*/}
                            {/*                         activeView: 'original',*/}
                            {/*                         callback: async () => {*/}
                            {/*                             this.setState({ updateCounter: this.state.updateCounter + 1 })*/}
                            {/*                         }*/}
                            {/*                     }*/}
                            {/*                 });*/}
                            {/*             }}*/}
                            {/*        >*/}
                            {/*<span className={`btn btn-icon btn-sm`}>*/}
                            {/*    <i className={`svg-icon icon-Doc_view_8 icon-color-primary`}/>*/}
                            {/*</span>*/}
                            {/*        </div>*/}
                            {/*    </div>*/}
                            {/*}*/}
                        </div>
                    );
                }

            }
        }

        let backToTableColor = this.state.backToTableTooltipShow
            ? "svg-icon icon-Delete icon-color-red"
            : "svg-icon icon-Delete icon-color-primary";


        let link = `${this.props.router.location.pathname}${this.props.router.location.search.split("&c")[0]}`;
        if (this.props.activeRow && this.props.activeRow.Version) {
            link += `&c=${this.props.activeRow.Version.IdDoc}`;
        }

        let buttonActiveStyleHalf = {};
        let buttonActiveStyleFull = {};
        let arrowButtonActiveStyleHalf = {};
        let arrowButtonActiveStyleFull = {};

        if (this.props.rootState.viewMode === RootComponentsStateViewModeTypes.DocumentsApp.PreviewCards_HalfScreen
            || this.props.rootState.viewMode === RootComponentsStateViewModeTypes.DocumentsApp.PreviewNormal_PreviewHalfScreen
            || this.props.rootState.viewMode === RootComponentsStateViewModeTypes.DocumentsApp.PreviewCards_RedactorMode_HalfScreen) {
            buttonActiveStyleHalf = {

                backgroundColor: "var(--icon-primary)",
                borderColor: "var(--icon-primary)"
            };
            arrowButtonActiveStyleHalf = {
                color: "white"
            }
        }
        if (this.props.rootState.viewMode === RootComponentsStateViewModeTypes.DocumentsApp.PreviewNormal_PreviewFullScreen
            || this.props.rootState.viewMode === RootComponentsStateViewModeTypes.DocumentsApp.PreviewCards_RedactorMode_FullScreen
            || this.props.rootState.viewMode === RootComponentsStateViewModeTypes.DocumentsApp.PreviewCards_FullScreen) {
            buttonActiveStyleFull = {
                backgroundColor: "var(--icon-primary)",
                borderColor: "var(--icon-primary)"
            };
            arrowButtonActiveStyleFull = {
                color: "white"
            }
        }

        let deleteDocumentIcon = "icon-Doc_view_9 icon-color-red";
        if (this.props?.activeRow?.Info.IsMarkedForDelete) {
            deleteDocumentIcon = "icon-Doc_view_7 icon-color-primary";
        }

        const isPreview = [rootStateType.DocumentsApp.PreviewNormal,
            rootStateType.DocumentsApp.PreviewNormal_PreviewHalfScreen,
            rootStateType.DocumentsApp.PreviewNormal_PreviewFullScreen].includes(this.props.rootState.viewMode)

        const isAttachFiles = preview.files.filter(file => file.isAttach).length > 0;
        const {adminLevel} = this.props;

        return (
            this.props.rootState.viewMode === RootComponentsStateViewModeTypes.DocumentsApp.PreviewNormal_Hide ?
                <>
                    <div className="card-body preview-hide col align-items-center" style={{flexBasis: 'auto'}}>
                        <div className="row" style={{ justifyContent: 'center' }}>
                                {
                                    this.state.showPreviewShow &&
                                    <MyTooltip target={this.showPreviewRef}
                                               text={"Раскрыть предпросмотр документа"}
                                               show={this.state.showPreviewShow}
                                               placement={"top"} delay={500}
                                    />
                                }
                                <button type="button" className="btn btn-outline p-0" onClick={() => {this.toggleSizePreview("halfScreen")}}
                                        ref={this.showPreviewRef}
                                        onMouseEnter={() => { this.setState({showPreviewShow: true}) }}
                                        onMouseLeave={() => { this.setState({showPreviewShow: false}) }}>
                                <span className="btn btn-icon btn-sm">
                                    <i style={{fontSize: '2rem'}} className="svg-icon icon-window_out_right icon-color-primary text-success" />
                                </span>
                                </button>
                                <div className="separator separator-solid mb-2 mt-2 hidden-in-1200" style={{minWidth: '3vw'}} />
                            {
                                this.props.viewMode === "normal" &&
                                <div className="d-flex align-items-center justify-content-center flex-wrap">
                                    {/*{*/}
                                    {/*    this.state.infoTooltipShow &&*/}
                                    {/*    <MyTooltip target={this.infoRef}*/}
                                    {/*               text={"Для просмотра файлов иных форматов, кроме PDF, необходимо скачать файл"}*/}
                                    {/*               show={this.state.infoTooltipShow}*/}
                                    {/*               placement={"left"} delay={500}*/}
                                    {/*    />*/}
                                    {/*}*/}
                                    {/*<span className="btn btn-icon btn-circle btn-sm icon-info-decor"*/}
                                    {/*      ref={this.infoRef}*/}
                                    {/*      onMouseEnter={()=>{this.setState({infoTooltipShow : true})}}*/}
                                    {/*      onMouseLeave={()=>{this.setState({infoTooltipShow : false})}}>*/}
                                    {/*     <i className="svg-icon icon-Info"/>*/}
                                    {/* </span>*/}
                                    {
                                        this.state.deleteDocumentTooltipShow &&
                                        <MyTooltip target={this.deleteDocumentRef}
                                                   text={"Пометить на удаление/Снять пометку"}
                                                   show={this.state.deleteDocumentTooltipShow}
                                                   placement={"top"} delay={500}
                                        />
                                    }
                                    {
                                        deleteAccess && this.props.adminLevel > AdminLevelEnum.CommonUser &&
                                        <span className="btn btn-icon btn-sm" ref={this.deleteDocumentRef}
                                              onClick={() => {
                                                  this.deleteDocument()
                                              }}
                                              onMouseEnter={() => {
                                                  this.setState({deleteDocumentTooltipShow: true})
                                              }}
                                              onMouseLeave={() => {
                                                  this.setState({deleteDocumentTooltipShow: false})
                                              }}>
                                        <i className={`svg-icon ${deleteDocumentIcon}`}/>
                                    </span>
                                    }
                                    {
                                        this.state.addNewCardTooltipShow &&
                                        <MyTooltip target={this.addNewCardRef}
                                                   text={"Карточка документа"}
                                                   show={this.state.addNewCardTooltipShow}
                                                   placement={"top"} delay={500}
                                        />
                                    }
                                    <Link to={link} className="btn btn-icon btn-sm" ref={this.addNewCardRef}
                                          onClick={this.addNewCard}
                                          onMouseEnter={() => {
                                              this.setState({addNewCardTooltipShow: true})
                                          }}
                                          onMouseLeave={() => {
                                              this.setState({addNewCardTooltipShow: false})
                                          }}>
                                        <i className="svg-icon icon-Table_edit_3 icon-color-primary"/>
                                    </Link>
                                </div>
                            }
                            <div className="separator separator-solid mb-2 mt-2 hidden-in-1200" style={{minWidth: '3vw'}} />
                            {
                                this.state.openInNewTabTooltipShow &&
                                <MyTooltip target={this.openInNewTabRef}
                                           text={"Открыть в новой вкладке"}
                                           show={this.state.openInNewTabTooltipShow}
                                           placement={"top"} delay={500}
                                />
                            }
                            <a href={this.props.preview.isReady ? activeLink : "#"}
                               ref={this.openInNewTabRef}
                               onMouseEnter={() => {
                                   this.setState({openInNewTabTooltipShow: true})
                               }}
                               onMouseLeave={() => {
                                   this.setState({openInNewTabTooltipShow: false})
                               }}
                               target="_blank"
                               rel="noreferrer"
                               className="btn btn-icon btn-sm notFocus">
                                <i style={{fontSize: '2rem'}} className="svg-icon icon-Doc_view_5 icon-color-primary"/>
                            </a>
                        </div>
                    </div>
                </>
                :
                <>
                    <div className="card-header beautiful-scroll-5">
                        <div className="row flex-lg-nowrap">
                        {
                            this.state.hidePreviewShow &&
                            <MyTooltip target={this.hidePreviewRef}
                                       text={"Скрыть предпросмотр документа"}
                                       show={this.state.hidePreviewShow}
                                       placement={"top"} delay={500}
                            />
                        }
                        {isPreview &&
                            <button type="button" className="btn btn-outline p-0" onClick={() => {this.toggleSizePreview("hide")}}
                                    ref={this.hidePreviewRef}
                                    onMouseEnter={() => { this.setState({hidePreviewShow: true}) }}
                                    onMouseLeave={() => { this.setState({hidePreviewShow: false}) }}>
                                <span className="btn btn-icon btn-sm">
                                    <i style={{fontSize: '2rem'}} className="svg-icon icon-window_out_left icon-color-primary text-success" />
                                </span>
                            </button>
                        }
                        <div className="card-title">
                            {
                                (isAttachFiles && !isRedactorMode) ?
                                    <FilesListDropdown docName={documentName}
                                                       preview={preview}
                                                       selectActivePreviewFile={this.selectActivePreviewFile}
                                    />
                                    :
                                    <h4 className="card-label text-weight-bolder text-color-primary"
                                        style={{whiteSpace: "nowrap"}}
                                        title={documentName}>
                                        {HelpFunctions.cutLongString(documentName, 15, true)}
                                    </h4>
                            }
                        </div>
                        {
                            this.props.viewMode === "card" &&
                            <div className="d-flex align-items-center">
                                {/*{*/}
                                {/*    this.state.infoTooltipShow &&*/}
                                {/*    <MyTooltip target={this.infoRef}*/}
                                {/*               text={"Для просмотра файлов иных форматов, кроме PDF, необходимо скачать файл"}*/}
                                {/*               show={this.state.infoTooltipShow}*/}
                                {/*               placement={"right"} delay={500}*/}
                                {/*    />*/}
                                {/*}*/}
                                {/*<span className="btn btn-icon btn-circle btn-sm icon-info-decor"*/}
                                {/*      ref={this.infoRef}*/}
                                {/*      onMouseEnter={() => {*/}
                                {/*          this.setState({infoTooltipShow: true})*/}
                                {/*      }}*/}
                                {/*      onMouseLeave={() => {*/}
                                {/*          this.setState({infoTooltipShow: false})*/}
                                {/*      }}>*/}
                                {/*         <i className="svg-icon icon-Info"/>*/}
                                {/*     </span>*/}
                                {
                                    (this.state.redactorModeTooltipShow && !this.props.redactorMode) &&
                                    <MyTooltip target={this.redactorModeRef}
                                               text={"Режим редактирования"}
                                               show={this.state.redactorModeTooltipShow}
                                               placement={"top"} delay={500}
                                    />
                                }
                                {
                                    (!this.props.redactorMode && modifyAccess && adminLevel > AdminLevelEnum.CommonUser) &&
                                    <div onClick={this.toggleRedactorMode} ref={this.redactorModeRef}
                                         onMouseEnter={() => {
                                             this.setState({redactorModeTooltipShow: true})
                                         }}
                                         onMouseLeave={() => {
                                             this.setState({redactorModeTooltipShow: false})
                                         }}>
                                    <span className="btn btn-icon btn-sm">
                                        <i className="svg-icon icon-Table_edit_1 icon-color-primary"/>
                                    </span>
                                    </div>
                                }

                                {
                                    (this.state.redactorModeTooltipShow && this.props.redactorMode) &&
                                    <MyTooltip target={this.redactorModeRef}
                                               text={"Сохранить изменения"}
                                               show={this.state.redactorModeTooltipShow}
                                               placement={"top"} delay={500}
                                    />
                                }
                                {
                                    this.props.redactorMode &&
                                    <div onClick={this.saveRedactorChanges} ref={this.redactorModeRef}
                                         onMouseEnter={() => {
                                             this.setState({redactorModeTooltipShow: true})
                                         }}
                                         onMouseLeave={() => {
                                             this.setState({redactorModeTooltipShow: false})
                                         }}>
                                    <span className="btn btn-icon btn-sm">
                                        <i className="svg-icon icon-Okey icon-color-primary"/>
                                    </span>
                                    </div>
                                }


                                {
                                    // this.state.uploadFileTooltipShow &&
                                    // <MyTooltip target={this.uploadFileRef}
                                    //            text={"Загрузить новый файл предпросмотра (pdf)"}
                                    //            show={this.state.uploadFileTooltipShow}
                                    //            placement={"top"} delay={500}
                                    // />
                                }
                                {
                                    this.state.uploadFileAttachmentTooltipShow &&
                                    <MyTooltip target={this.uploadFileAttachmentRef}
                                               text={"Загрузить новый файл"}
                                               show={this.state.uploadFileAttachmentTooltipShow}
                                               placement={"top"} delay={500}
                                    />
                                }
                                {
                                    ((this.props.redactorMode && modifyAccess) || ( adminLevel === AdminLevelEnum.CommonUser && modifyAccess))
                                    &&
                                    <React.Fragment>
                                        {/*<div onClick={this.uploadFile} ref={this.uploadFileRef}*/}
                                        {/*     onMouseEnter={() => {this.setState({uploadFileTooltipShow: true}) }}*/}
                                        {/*     onMouseLeave={() => {this.setState({uploadFileTooltipShow: false})}}>*/}
                                        {/*   <span className="btn btn-icon btn-sm">*/}
                                        {/*       <i className="svg-icon icon-Upload_document icon-color-primary"/>*/}
                                        {/*   </span>*/}
                                        {/*</div>*/}
                                        <div onClick={this.uploadFileAttachment} ref={this.uploadFileAttachmentRef}
                                             onMouseEnter={() => {
                                                 this.setState({uploadFileAttachmentTooltipShow: true})
                                             }}
                                             onMouseLeave={() => {
                                                 this.setState({uploadFileAttachmentTooltipShow: false})
                                             }}>
                                        <span className="btn btn-icon btn-sm">
                                            <i className="svg-icon icon-Doc_view_8 icon-color-primary"/>
                                        </span>
                                        </div>
                                    </React.Fragment>
                                }

                                {
                                    (this.state.backToTableTooltipShow && !this.props.redactorMode) &&
                                    <MyTooltip target={this.backToTableRef}
                                               text={"Вернуться в реестр"}
                                               show={this.state.backToTableTooltipShow}
                                               placement={"top"} delay={500}
                                    />
                                }
                                {
                                    !this.props.redactorMode &&
                                    <span className="btn btn-icon btn-sm" ref={this.backToTableRef}
                                          onClick={this.backToTable}
                                          onMouseEnter={() => {
                                              this.setState({backToTableTooltipShow: true})
                                          }}
                                          onMouseLeave={() => {
                                              this.setState({backToTableTooltipShow: false})
                                          }}
                                    >
                                        <i className={"svg-icon icon-undo_16 icon-color-primary"}/>
                                    </span>
                                }

                                {
                                    (this.state.backToTableTooltipShow && this.props.redactorMode) &&
                                    <MyTooltip target={this.backToTableRef}
                                               text={"Отменить редактирование"}
                                               show={this.state.backToTableTooltipShow}
                                               placement={"top"} delay={500}
                                    />
                                }
                                {
                                    this.props.redactorMode &&
                                    <span className="btn btn-icon btn-sm" ref={this.backToTableRef}
                                          onClick={this.toggleRedactorMode}
                                          onMouseEnter={() => {
                                              this.setState({backToTableTooltipShow: true})
                                          }}
                                          onMouseLeave={() => {
                                              this.setState({backToTableTooltipShow: false})
                                          }}>
                                <i className={backToTableColor}/>
                            </span>
                                }
                            </div>
                        }
                        {
                            this.props.viewMode === "normal" &&
                            <div className="d-flex align-items-center">
                                {/*{*/}
                                {/*    this.state.infoTooltipShow &&*/}
                                {/*    <MyTooltip target={this.infoRef}*/}
                                {/*               text={"Для просмотра файлов иных форматов, кроме PDF, необходимо скачать файл"}*/}
                                {/*               show={this.state.infoTooltipShow}*/}
                                {/*               placement={"left"} delay={500}*/}
                                {/*    />*/}
                                {/*}*/}
                                {/*<span className="btn btn-icon btn-circle btn-sm icon-info-decor"*/}
                                {/*      ref={this.infoRef}*/}
                                {/*      onMouseEnter={()=>{this.setState({infoTooltipShow : true})}}*/}
                                {/*      onMouseLeave={()=>{this.setState({infoTooltipShow : false})}}>*/}
                                {/*      <i className="svg-icon icon-Info"/>*/}
                                {/* </span>*/}
                                {
                                    this.state.deleteDocumentTooltipShow &&
                                    <MyTooltip target={this.deleteDocumentRef}
                                               text={"Пометить на удаление/Снять пометку"}
                                               show={this.state.deleteDocumentTooltipShow}
                                               placement={"top"} delay={500}
                                    />
                                }
                                {
                                    deleteAccess && this.props.adminLevel > AdminLevelEnum.CommonUser &&
                                    <span className="btn btn-icon btn-sm" ref={this.deleteDocumentRef}
                                          onClick={() => {
                                              this.deleteDocument()
                                          }}
                                          onMouseEnter={() => {
                                              this.setState({deleteDocumentTooltipShow: true})
                                          }}
                                          onMouseLeave={() => {
                                              this.setState({deleteDocumentTooltipShow: false})
                                          }}>
                                    <i className={`svg-icon ${deleteDocumentIcon}`}/>
                                </span>
                                }


                                {
                                    this.state.addNewCardTooltipShow &&
                                    <MyTooltip target={this.addNewCardRef}
                                               text={"Карточка документа"}
                                               show={this.state.addNewCardTooltipShow}
                                               placement={"top"} delay={500}
                                    />
                                }
                                <Link to={link} className="btn btn-icon btn-sm" ref={this.addNewCardRef}
                                      onClick={this.addNewCard}
                                      onMouseEnter={() => {
                                          this.setState({addNewCardTooltipShow: true})
                                      }}
                                      onMouseLeave={() => {
                                          this.setState({addNewCardTooltipShow: false})
                                      }}>
                                    <i className="svg-icon icon-Table_edit_3 icon-color-primary"/>
                                </Link>


                            </div>
                        }
                        </div>
                    </div>
                    <div style={{marginTop: "10px", color: "darkGrey", wordBreak: "break-word"}}>Для просмотра файлов иных форматов, кроме PDF, необходимо скачать файл</div>
                    {body}
                    <div className="card-footer">
                        <div className="btn-toolbar-preview card-toolbar">

                            {
                                this.state.selectFileTooltipShow &&
                                <MyTooltip target={this.selectFileRef}
                                           text={"Выбрать файл предпросмотра"}
                                           show={this.state.selectFileTooltipShow}
                                           placement={"top"} delay={500}
                                />
                            }
                            <Dropdown>
                                <Dropdown.Toggle className="btn btn-circle btn-outline-success dropdown-toggle"
                                                 ref={this.selectFileRef}
                                                 onMouseEnter={() => {
                                                     this.setState({selectFileTooltipShow: true})
                                                 }}
                                                 onMouseLeave={() => {
                                                     this.setState({selectFileTooltipShow: false})
                                                 }}>
                                    <i className="svg-icon icon-Doc_view_12"/>
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item key={createUniqueIdString(3)}
                                                   className={`dropdown-item ${preview.activeView === "original" ? "active" : ""}`}
                                                   onClick={() => this.selectViewActiveFile("original")}>Оригинал
                                    </Dropdown.Item>
                                    <Dropdown.Item key={createUniqueIdString(3)}
                                                   className={`dropdown-item ${preview.activeView === "preview" ? "active" : ""}`}
                                                   onClick={() => this.selectViewActiveFile("preview")}>Предпросмотр
                                    </Dropdown.Item>
                                    {//todo было отключенно для карточки
                                        <Dropdown.Item key={createUniqueIdString(3)}
                                                   className={`dropdown-item ${preview.activeView === "content" ? "active" : ""}`}
                                                   onClick={() => this.selectViewActiveFile("content")}>Содержание
                                        </Dropdown.Item>
                                    }
                                </Dropdown.Menu>
                            </Dropdown>

                            {
                                this.state.halfScreenTooltipShow &&
                                <MyTooltip target={this.halfScreenRef}
                                           text={"Увеличенный предпросмотр"}
                                           show={this.state.halfScreenTooltipShow}
                                           placement={"top"} delay={500}
                                />
                            }
                            <span className="btn btn-icon btn-outline-success btn-circle btn-sm hidden-in-1200"
                                  ref={this.halfScreenRef}
                                  style={buttonActiveStyleHalf}
                                  onMouseEnter={() => {
                                      this.setState({halfScreenTooltipShow: true})
                                  }}
                                  onMouseLeave={() => {
                                      this.setState({halfScreenTooltipShow: false})
                                  }}
                                  onClick={() => {
                                      this.toggleSizePreview("halfScreen")
                                  }}>
                            <i className="svg-icon icon-Doc_view_2" style={arrowButtonActiveStyleHalf}/>
                            </span>

                            {
                                this.state.fullScreenTooltipShow &&
                                <MyTooltip target={this.fullScreenRef}
                                           text={"Полноэкранный предпросмотр"}
                                           show={this.state.fullScreenTooltipShow}
                                           placement={"top"} delay={500}
                                />
                            }
                            <span className="btn btn-icon btn-outline-success btn-circle btn-sm hidden-in-1200"
                                  ref={this.fullScreenRef}
                                  style={buttonActiveStyleFull}
                                  onMouseEnter={() => {
                                      this.setState({fullScreenTooltipShow: true})
                                  }}
                                  onMouseLeave={() => {
                                      this.setState({fullScreenTooltipShow: false})
                                  }}
                                  onClick={() => {
                                      this.toggleSizePreview("fullScreen")
                                  }}>
                            <i className="svg-icon icon-Doc_view_3"
                               style={arrowButtonActiveStyleFull}
                            />
                        </span>

                            {/*TODO aa 08.11.2023 возможно когда-нибудь это вернем*/}
                            {/*{*/}
                            {/*    this.state.recreateFileTooltipShow &&*/}
                            {/*    <MyTooltip target={this.recreateFile}*/}
                            {/*           text={"Пересоздать"}*/}
                            {/*           show={this.state.recreateFileTooltipShow}*/}
                            {/*           placement={"top"} delay={500}*/}
                            {/*/>*/}
                            {/*}*/}
                            {/*<span className="btn btn-icon btn-outline-success btn-circle btn-sm"*/}
                            {/*    ref={this.recreateFile}*/}
                            {/*    // style={buttonActiveStyleFull}*/}
                            {/*    onMouseEnter={() => {*/}
                            {/*        this.setState({recreateFileTooltipShow: true})*/}
                            {/*    }}*/}
                            {/*    onMouseLeave={() => {*/}
                            {/*        this.setState({recreateFileTooltipShow: false})*/}
                            {/*    }}*/}
                            {/*    onClick={() => this.recreatePreviewDoc("recreate")}*/}
                            {/*>*/}
                            {/*        <i className="bi bi-arrow-clockwise"*/}
                            {/*           // style={arrowButtonActiveStyleFull}*/}
                            {/*        ></i>*/}
                            {/*</span>*/}
                            {/*{*/}
                            {/*    this.state.updateFileTooltipShow &&*/}
                            {/*    <MyTooltip target={this.updateFile}*/}
                            {/*               text={"Обновить"}*/}
                            {/*               show={this.state.updateFileTooltipShow}*/}
                            {/*               placement={"top"} delay={500}*/}
                            {/*    />*/}
                            {/*}*/}
                            {/*<span className="btn btn-icon btn-outline-success btn-circle btn-sm"*/}
                            {/*    ref={this.updateFile}*/}
                            {/*    // style={buttonActiveStyleHalf}*/}
                            {/*    onMouseEnter={() => {*/}
                            {/*        this.setState({updateFileTooltipShow: true})*/}
                            {/*    }}*/}
                            {/*    onMouseLeave={() => {*/}
                            {/*        this.setState({updateFileTooltipShow: false})*/}
                            {/*    }}*/}
                            {/*    onClick={()=>this.props.setModalData({name:ModalTypes.documents.updatePreviewFile,data:{}})}*/}
                            {/*>*/}
                            {/*        <i className="bi bi-pencil-square"*/}
                            {/*           // style={arrowButtonActiveStyleFull}*/}
                            {/*        ></i>*/}
                            {/*</span>*/}

                            {
                                this.state.openInNewTabTooltipShow &&
                                <MyTooltip target={this.openInNewTabRef}
                                           text={"Открыть в новой вкладке"}
                                           show={this.state.openInNewTabTooltipShow}
                                           placement={"top"} delay={500}
                                />
                            }
                            <a href={preview.isReady ? activeLink : "#"}
                               ref={this.openInNewTabRef}
                               onMouseEnter={() => {
                                   this.setState({openInNewTabTooltipShow: true})
                               }}
                               onMouseLeave={() => {
                                   this.setState({openInNewTabTooltipShow: false})
                               }}
                               target="_blank"
                               rel="noreferrer"
                               className="btn btn-icon btn-outline-success btn-circle btn-sm notFocus"
                            >
                                <i className="svg-icon icon-Doc_view_5"/>
                            </a>
                        </div>
                    </div>
                </>
        );
    }
}


const  mapStateToProps = state => {
    return {
        additionalSectionsData: state.document.additionalSections,
        preview : state.document.preview,
        rootState : state.document.rootState,
        activeRow : state.document.mainTable.activeRow,
        activeNode : state.document.tree.activeNode,
        // content : state.document.cards.collection[cardIndex].additionalSections.contentSection.content,

        cards : state.document.cards,
        router : state.router,

        redactorDataIsUpdated : state.document.cards.redactorDataCollected.isUpdatedInAll,
        adminLevel : state.globalState.user.AdminLevel,
        tree_docs: state.document.tree.render.children
    }
}

const  mapDispatchToProps = {
    addModalData,
    selectActiveFileForPreview,
    setSizePreview,
    changeDocumentViewMode,
    selectActiveFileForPreview_Card,
    selectActiveDocumentCard,
    createRedactorData,
    createDocumentCards,
    setModalData,
    setStateLeftAsideMenu,
    changeVersionDocumentCards,
    updateUserSettings,
    changeViewMode,
    setFilesContent,
    selectViewActiveFileForPreview,
    collectDataForAdditionalSections_Normal,
    setLoaderModalData,

    mainTableDownloadDocCollection,
    combineMainTableAttributes,
    selectActiveRow,
    resetDocumentPreview,
    createPreviewBySelectDocument,
    treeSelectNode
}

export default connect(mapStateToProps,mapDispatchToProps)(DocPreview);
